import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { AssetDataField } from '@telespot/sdk';

export interface LabelConfig {
  label: string;
  configId: string;
  color: string;
}

export interface MethodTypePipeline {
  pipeline: string;
  configId: string;
}

export interface MethodType {
  id: string;
  pipelineIds: Record<string, MethodTypePipeline>;
  labelConfig: Record<string, LabelConfig>;
  acquisitionFields: AssetDataField[];
}

export interface MethodTypeState extends EntityState<MethodType> {
  loading: boolean;
  error: string | null;
}

export const methodTypeAdapter = createEntityAdapter<MethodType>();
